import { css } from "@emotion/react";

export function ModalGraLoginlCss() {
  return css`
        background:red;
       

    .Modal {
   
      h2 {
        background: linear-gradient(90deg, #34c6f1 6.22%, #1fdd8f 77.34%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .content {
        font-style: normal;
        font-weight: 500;
        line-height: 166.667%;
        font-size: calc(0.6rem + 0.9vw);
      }
      .header-with-image{
        background: linear-gradient(90deg, #34c6f1 6.22%, #1fdd8f 77.34%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        
      }

      form{
        .Blue{
                background: #34C6F1 !important;
            }
    .Button {
            display: inline-block;
            outline: none;
            cursor: pointer;
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
            border-radius: 8px;
            padding: 10px 18px;
            border: none !important;
            transition: box-shadow 0.2s ease, transform 0.1s ease;
            background: #fff;
            color: #222222;

            &:hover {
                border: none !important;
                background: #f7f7f7;
            }
        }}
     
    }
  `;
}
